import React from 'react'
import {
   makeStyles,
   FormControl,
   FormLabel,
   Grid,
   CircularProgress
} from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { green } from '@material-ui/core/colors'

const useStyles = makeStyles(theme => ({
   ListContainer: {
      display: 'inline-block',
      marginRight: theme.spacing(0.5),
      width: 'calc(20% - 4px)',
      boxShadow:
         '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
   },
   list: {
      flexWrap: 'nowrap',
      width: '100%',
      paddingLeft: theme.spacing(2.5),
      overflowY: 'scroll',
      overflowX: 'hidden',
      backgroundColor: '#f9fafc',
      fontSize: '15px !important',
      color: '#afb9c3',
      height: 330
   },
   checked: {
      color: green[500],
      height: 18
   },
   spinner: {
      color: 'primary'
   },
   titleContainer: {
      padding: theme.spacing(2, 2.5),
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'space-between'
   },
   title: {
      color: '#000',
      fontWeight: 500,
      fontSize: 16
   }
}))

const ListContainer = ({ title, children, check = false, loading = false }) => {
   const classes = useStyles()
   return (
      <Grid className={classes.ListContainer}>
         <Grid className={classes.titleContainer}>
            {title && (
               <FormLabel component="legend" className={classes.title}>
                  {title}
               </FormLabel>
            )}
            {!loading && check && (
               <CheckCircleOutlineIcon className={classes.checked} />
            )}
            {loading && (
               <CircularProgress size={16} className={classes.spinner} />
            )}
         </Grid>
         <Grid className={classes.list}>
            <FormControl component="fieldset">{children}</FormControl>
         </Grid>
      </Grid>
   )
}

export default ListContainer
